export const PayrollOvertimeStatus = {
    Approved: {
        description: 'Aprobado',
        color: '#4CAF50',
        id: 'Aprobado',
    },
    Rejected: {
        description: 'Rechazado',
        color: '#F44336',
        id: 'Rechazado',
    },
    Review: {
        description: 'Revisado',
        color: '#E8BC52',
        id: 'Revisado',
    },
    Draft: {
        description: 'Borrador',
        color: '#2196F3',
        id: 'Borrador',
    },
    RevisiOn: {
        description: 'Revisión',
        color: '#f3c321',
        id: 'Revisión',
    },
    Undefined: {
        description: 'Indefinido',
        color: '#ff8800ff',
        id: 'Indefinido',
    },
}